// Event-Bus für übergreifende Anwendungsereignisse
const eventBus = new EventTarget();

// Event-Typen
export const EventTypes = {
  AUTH_IMPERSONATED: 'auth:impersonated',
  AUTH_CHANGED: 'auth:changed',
  AUTH_LOGOUT: 'auth:logout'
};

export default eventBus; 